import React from 'react';
import LightLogo from '../../assets/logo/light.svg';
import DarkLogo from '../../assets/logo/dark.svg';
import { useTheme } from '@dewise-devex/backstage-plugin-mui-uikit-react';

const Logo = () => {
  const { theme } = useTheme();

  const imageSource = React.useMemo(() => {
    return theme === 'light' ? LightLogo : DarkLogo;
  }, [theme]);

  return <img src={imageSource} alt="Company Logo" width="79px" />;
};

export default Logo;
